import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listRoles: [],
};

const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setListRoles: (state, action) => {
      state.listRoles = action.payload.listRoles ?? [];
    },
    clearListRoles: (state) => {
      state.listRoles = [];
    },
  },
});

export const { setListRoles, clearListRoles } = rolesSlice.actions;
export default rolesSlice.reducer;
